/** Concatène des classes conditionnelles (mini clsx interne, zéro dépendance). */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
